export default {
	data() {
		return {
			moduleName: 'businessModels',
			detailPageRouteName: 'businessModelsDetail',
			entity: {
				included_device_count: 4,
				included_firstscreen_device_count: 1,
				'default_subscriber_profile_name': null,
				'default_child_subscriber_profile_name': null,
				'create_default_child_subscriber_profile': null,
				vod_providers: [],
				vod_package_settings: {},
			},
			updateFields: [
				'name',
				'description',
				'included_device_count',
				'included_firstscreen_device_count',
				'default_subscriber_profile_name',
				'default_child_subscriber_profile_name',
				'create_default_child_subscriber_profile',
				'vod_providers',
				'vod_package_settings',
				'advertising_providers_order',
			],
		}
	},
	methods: {
		filterFormParams(params) {
			let allowed = {}
			this._.forOwn(params, function (value, key) {
				if (this.updateFields.includes(key)) {
					allowed[key] = value
				}
			}.bind(this))
			return allowed
		},
		resetFields() {
			this.$refs['businessmodelformref'].validateBusinessModelFormRequiredFields()
			this.$refs['businessmodelformref'].$refs['nameref'].setTouched(false)
			this.$refs['businessmodelformref'].$refs['descriptionref'].setTouched(false)
		},
		processErrorMessage(error) {
			let errorMessage = null;
			this.$refs['businessmodelformref'].validateBusinessModelFormRequiredFields()

			this._.forEach(error['validation_errors'], function (message) {
				if (message.match("^Name \"(.+)\" is not unique\.$")) {
					errorMessage = this.$gettext('Název business modelu musí být unikátní.');
					this.$refs['businessmodelformref'].$refs['nameref'].setForcedInvalid(true, this.$gettext('Název business modelu musí být unikátní'));
				}
			}.bind(this))

			return error['error_message'] = errorMessage || error['error_message'];
		},
		_processDetailErrorMessage(error) {
			let deleteError = null
			this._.forEach(error['validation_errors'], function (errorMessage) {
				deleteError = errorMessage;
			}.bind(this))

			if (deleteError) {
				error['error_message'] = deleteError
			}

			return error['error_message']
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/views/businessModels/mixins/businessModels.js